// Apolo IDE — cost estimator (renderer mirror).
//
// Uses the same MODEL_REGISTRY pricing as the server (modelPrices.js). The
// renderer estimates token counts heuristically (chars / 4) so the user
// sees a running cost as they type; the server reports authoritative cost
// after each turn.

import { MODEL_REGISTRY, findModel } from './modelRegistry.js';

const APPROX_CHARS_PER_TOKEN = 4;

/** Heuristic token count from text — does not call a tokenizer. */
export function approxTokens(text) {
  if (typeof text !== 'string' || text.length === 0) return 0;
  return Math.ceil(text.length / APPROX_CHARS_PER_TOKEN);
}

export function estimateCostUSD(modelId, { input_tokens = 0, output_tokens = 0 } = {}) {
  const entry = findModel(modelId);
  if (!entry) return 0;
  const inputCost = (input_tokens / 1_000_000) * entry.pricing.input;
  const outputCost = (output_tokens / 1_000_000) * entry.pricing.output;
  return Number((inputCost + outputCost).toFixed(6));
}

/** Coarse pre-send estimate from a prompt + expected response length. */
export function estimatePreSend(modelId, promptText, expectedOutputChars = 800) {
  return estimateCostUSD(modelId, {
    input_tokens: approxTokens(promptText),
    output_tokens: approxTokens(' '.repeat(expectedOutputChars)),
  });
}

export { MODEL_REGISTRY };
